import { useState } from "react";
import Button from './../../../components/common/Button';
import Modal from "./../../../components/modals/Modal"; // Importa el componente Modal

const ProgramaArquitectonico = ({
  index, nivel, detalles, espaciosDatos, manejarEspaciosSeleccionados, onNivelChange
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [espaciosSeleccionados, setEspaciosSeleccionados] = useState(detalles || []); // Cargar los espacios seleccionados iniciales

  const abrirModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const cerrarModal = (e) => {
    e.preventDefault();
    setIsModalOpen(false);
  };

  // Maneja la selección o deselección de espacios
  const manejadorItems = (itemId, itemNombre) => {
    const nuevoEspacio = { id: itemId, nombre: itemNombre, cantidad: 1 }; // Default cantidad 1
    if (espaciosSeleccionados.some(item => item.id === itemId)) {
      setEspaciosSeleccionados(espaciosSeleccionados.filter(item => item.id !== itemId)); // Desmarcar espacio
    } else {
      setEspaciosSeleccionados([...espaciosSeleccionados, nuevoEspacio]); // Marcar espacio
    }
  };

  // Maneja la cantidad de los espacios seleccionados
  const manejarCantidad = (e, itemId) => {
    const cantidad = parseInt(e.target.value, 10);
    setEspaciosSeleccionados(prev =>
      prev.map(item =>
        item.id === itemId ? { ...item, cantidad: cantidad } : item
      )
    );
  };

  // Guardar los cambios de los espacios seleccionados cuando se presiona "Guardar"
  const guardarEspaciosSeleccionados = (e) => {
    e.preventDefault()
    manejarEspaciosSeleccionados(index, espaciosSeleccionados); // Guardar los espacios seleccionados al estado global
    setIsModalOpen(false); // Cerrar el modal después de guardar
  };

  return (
    <div className="flex gap-4 items-center mb-2">
      <div className="flex flex-col">
        <input
          id={`nivel-${index}`}
          name={`nivel-${index}`}
          type="text"
          value={nivel || ""}
          onChange={(e) => onNivelChange(index, e.target.value)}
          className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
          placeholder={`Nivel ${index + 1}`}
        />
      </div>

      <div className="flex flex-col flex-grow w-full">
        <button
          className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 text-left"
          onClick={abrirModal}
        >
          {espaciosSeleccionados.length > 0
            ? `Espacios seleccionados: ${espaciosSeleccionados
              .map(item => `${item.cantidad} ${item.nombre}`)
              .join(" + ")}`
            : `Agregar detalle del nivel ${index + 1}`}
        </button>
      </div>



      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={cerrarModal}
        title={`Detalle del Nivel ${index + 1}`}
        size="md"
      >
        <div className="mt-1 grid grid-cols-3 gap-2 text-center">
          {espaciosDatos.map((item) => (
            <div
              key={item.id}
              className={`text-[13px] border p-2 rounded-md cursor-pointer ${espaciosSeleccionados.some(i => i.id === item.id) ? "bg-blue-400 text-white" : "hover:bg-gray-200"}`}
              onClick={() => manejadorItems(item.id, item.espacio)}
            >
              {item.espacio}
            </div>
          ))}
        </div>

        {/* Mostrar los ítems seleccionados */}
        <h3 className="mt-4 font-bold mb-2">Ítems Seleccionados:</h3>
        {espaciosSeleccionados.length > 0 && (
          <div className="p-4 border border-gray-300 rounded-md bg-gray-50">
            <div className="space-y-4">
              {espaciosSeleccionados.map((item) => (
                <div key={item.id} className="flex items-center justify-between">
                  <input
                    type="number"
                    value={item.cantidad}
                    onChange={(e) => manejarCantidad(e, item.id)}
                    className="border border-gray-300 rounded-md px-2 py-1 text-sm w-40 mr-2"
                    placeholder="Cantidad"
                  />
                  <span className="flex-grow">{item.nombre}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-end mt-4">
          <Button texto="Guardar" type="save" onClick={guardarEspaciosSeleccionados} />
        </div>
      </Modal>
    </div>
  );
};

export default ProgramaArquitectonico;
